export default class VehicleType {
  id: string = '';
  name: string = '';
  seatCapacity: number = 0;
  luggageCapacity: number = 0;
  safetySeatCapacity: number = 0;
  price: number = 0;
  localeKey: string = '';

  constructor(data: Partial<VehicleType> = {}) {
    Object.assign(this, data);
  }

  get isValid(): boolean {
    return Boolean(this.id && this.name && this.seatCapacity > 0);
  }

  clone(): VehicleType {
    return new VehicleType(this);
  }
}